<template>
  <i v-if="isIconfont"
     :class="['iconfont', iconClass]"
     :style="iconStyle"></i>
  <span v-else
        :class="iconClass"
        :style="iconStyle"></span>
</template>

<script>
import { computed } from 'vue'
import '@/assets/fonts/icon/iconfont.css'

const ICONFONT_TYPES = [
  'icon-shouji',
  'icon-shouji1',
  'icon-fixed-telephone',
  'icon-wangluo',
  'icon-2fengongsi',
  'icon-Linkedin',
  'icon-twitter',
  'icon-youtub',
  'icon-a-25pp_lianshu_facebook',
  'icon-lianjie',
  'icon-erweima',
  'icon-erweima1',
  'icon-zhedie-zhankai',
  'icon-zhedie-shouqi',
  'icon-qita',
  'icon-a-yuyanyingwen',
  'icon-shoucang',
  'icon-tongxunlu',
  'icon-baocun',
  'icon-instagram',
  'icon-fenxiang_o',
  'icon-weixin',
  'icon-yunweigongsi',
  'icon-tuichu',
  'icon-gengduo',
  'icon-cardb',
  'icon-shouye',
  'icon-fuhao-shouye',
  'icon-jiaohuan',
  'icon-yincang',
  'icon-shezhi',
  'icon-a-166-NFC',
  'icon-qiapian',
  'icon-gouwuche',
  'icon-suoding',
  'icon-kefu',
  'icon-youjian',
  'icon-mobilepayment_px',
  'icon-zhiwen',
  'icon-jiesuo',
  'icon-a-24px',
  'icon-yijianqueren',
  'icon-yonghutiaokuan',
  'icon-yamaxun',
  'icon-googlepay',
  'icon-zhifu-pingguozhifu',
  'icon-pulsometer',
  'icon-xinxi',
  'icon-shoucangxing2',
  'icon-shanchu',
  'icon-Pin-Code',
  'icon-chakan',
  'icon-dianzan',
  'icon-iconfontzhizuobiaozhun44',
  'icon-xingxing1',
  'icon-dianzan1',
  'icon-iosgengduo',
  'icon-shaixuanguolv',
  'icon-shangyiyehoutuifanhui',
  'icon-xiayiyeqianjinchakangengduo',
  'icon-xiangxiazhankai',
  'icon-zhixiangzuo',
  'icon-zhixiangyou',
  'icon-xiangshangshouqi',
  'icon-zhixiangxia',
  'icon-biaotou-zhengxu',
  'icon-biaotou-kepaixu',
  'icon-biaotou-daoxu',
  'icon-shangchuan',
  'icon-yincangxianshi',
  'icon-plus',
  'icon-wode',
  'icon-shenfenzheng-xianxingtubiao-01',
  'icon-plus-circle',
  'icon-kehuguanxi',
  'icon-zhibo',
]

const ELEMENT_ICONS = {
  email: 'el-icon-message',
  phone: 'el-icon-phone',
  location: 'el-icon-location',
  msg: 'el-icon-chat-dot-round',
  chat: 'el-icon-chat-dot-round',
  'chat-round': 'el-icon-chat-line-round',
  person: 'el-icon-user',
  'person-filled': 'el-icon-user-solid',
  personoutline: 'el-icon-user',
  company: 'el-icon-office-building',
  postcard: 'el-icon-postcard',
  'phone-outline': 'el-icon-phone-outline',
  data: 'el-icon-data-line',
  users: 'el-icon-user-solid',
  logout: 'el-icon-switch-button',
  share: 'el-icon-share',
  menu: 'el-icon-menu',
  tickets: 'el-icon-tickets',
  picture: 'el-icon-picture',
  'picture-outline': 'el-icon-picture-outline',
  document: 'el-icon-document',
  download: 'el-icon-download',
  upload: 'el-icon-upload',
  plus: 'el-icon-plus',
  minus: 'el-icon-minus',
  close: 'el-icon-close',
  check: 'el-icon-check',
  arrowleft: 'el-icon-arrow-left',
  arrowright: 'el-icon-arrow-right',
  arrowup: 'el-icon-arrow-up',
  arrowdown: 'el-icon-arrow-down',
  back: 'el-icon-back',
  right: 'el-icon-right',
  top: 'el-icon-top',
  bottom: 'el-icon-bottom',
  house: 'el-icon-house',
  setting: 'el-icon-setting',
  tools: 'el-icon-tools',
  delete: 'el-icon-delete',
  edit: 'el-icon-edit',
  editoutline: 'el-icon-edit-outline',
  search: 'el-icon-search',
  view: 'el-icon-view',
  hide: 'el-icon-hide',
  show: 'el-icon-show',
  lock: 'el-icon-lock',
  unlock: 'el-icon-unlock',
  key: 'el-icon-key',
  bell: 'el-icon-bell',
  info: 'el-icon-info',
  warning: 'el-icon-warning',
  success: 'el-icon-success',
  error: 'el-icon-error',
  refresh: 'el-icon-refresh',
  monitor: 'el-icon-monitor',
  mobile: 'el-icon-mobile',
  connection: 'el-icon-Connection',
  coordinate: 'el-icon-coordinate',
  avatar: 'el-icon-avatar',
  guide: 'el-icon-guide',
  promotion: 'el-icon-promotion',
  'data-board': 'el-icon-data-board',
  'pie-chart': 'el-icon-pie-chart',
  'chart-line': 'el-icon-line-chart',
  histogram: 'el-icon-histogram',
  grid: 'el-icon-grid',
  operation: 'el-icon-operation',
  list: 'el-icon-list',
  clipboard: 'el-icon-clipboard',
  clock: 'el-icon-clock',
  sort: 'el-icon-sort',
  filter: 'el-icon-filter',
  'edit-pen': 'el-icon-editpen',
  'eliconscustom': 'el-icon-s-custom',
}

export default {
  name: 'UniIcons',
  props: {
    type: {
      type: String,
      default: '',
    },
    customPrefix: {
      type: String,
      default: '',
    },
    size: {
      type: [Number, String],
      default: 18,
    },
    color: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const isIconfont = computed(() => {
      return (
        props.customPrefix === 'iconfont' ||
        ICONFONT_TYPES.some(t => props.type.includes(t)) ||
        props.type.startsWith('icon-')
      )
    })

    const iconClass = computed(() => {
      if (isIconfont.value) {
        if (props.type.startsWith('icon-')) {
          return props.type
        }
        return 'icon-' + props.type.replace(/([A-Z])/g, '-$1').toLowerCase()
      }
      const type = props.type.toLowerCase().replace(/-/g, '')
      console.log('===========', type, ELEMENT_ICONS[type])
      return ELEMENT_ICONS[type] || 'el-icon-edit'
    })

    const iconStyle = computed(() => ({
      fontSize: props.size + 'px',
      color: props.color,
    }))

    return {
      isIconfont,
      iconClass,
      iconStyle,
    }
  },
}
</script>

<style scoped>
.iconfont {
  display: inline-block;
  line-height: 1;
}
</style>
